import styled from '@emotion/styled';
import { theme } from '../../../../theme';

export const StyledDrawerContent = styled.div`
  padding: ${theme.spacing(2)};
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 16px;
`;

export const StyledHeader = styled.div`
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 6px;
`;
